// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

/* eslint-disable */
var jQuery = require("jquery");

export function upperCaseString(text = "") {
  if (text.length < 0) return "";
  return text.replace(/\b\w/g, l => l.toUpperCase());
}

export function getOffset(el) {
  el = el.getBoundingClientRect();
  return {
    left: el.left + window.scrollX,
    top: el.top + window.scrollY
  };
}

export function slugify(text = "", toLower = true) {
  let textString = toLower ? text.toString() : text.toString();
  return textString
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}
export function unslugify(text) {
  return text.toString().replace(/-/g, " ");
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function validateHue(huey) {
  var lewis = parseInt(huey);
  var news = lewis;
  if (hh > 360) {
    news = lewis - 360;
  }
  if (hh < 0) {
    news = lewis + 360;
  }
  return news;
}

export function validatePercentage(perc) {
  var percC = parseInt(perc);
  var percV = percC;
  if (percC > 100) {
    percV = 100;
  }
  if (percC < 0) {
    percV = 0;
  }
  return percV;
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js